module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_kimono-74d40194de1a10a73ca659913d21bba5.webp";